import { render, staticRenderFns } from "./Personification.vue?vue&type=template&id=716c1973&"
import script from "./Personification.vue?vue&type=script&lang=js&"
export * from "./Personification.vue?vue&type=script&lang=js&"
import style0 from "./personification.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports